<template>
    <svg :class="design" :width="width" :height="height" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="11" fill="#5AC387"/>
        <path d="M14.3294 7.68252L9.46251 12.5464L7.67305 10.758C7.58608 10.6711 7.44544 10.6711 7.35846 10.758L6.83476 11.2814C6.74779 11.3683 6.74779 11.5089 6.83476 11.5958L9.30337 14.0629C9.39034 14.1498 9.53098 14.1498 9.61796 14.0629L15.1658 8.51844C15.2528 8.43152 15.2528 8.29097 15.1658 8.20405L14.6421 7.68067C14.5552 7.59375 14.4145 7.59375 14.3275 7.68067L14.3294 7.68252Z" fill="white"/>
    </svg>
</template>
<script>
    export default {
        name: 'ui-circle-v',
        props: {
            design: {
                type: String,
                default: ''
            },
            fill: {
                type: String,
                default: '#FFF'
            },
            width: {
                type: [String, Number],
                default: 22
            },
            height: {
                type: [String, Number],
                default: 22
            }
        }
    }
</script>